<template>
	<multi-select
		min-height="40px"
		class="p-multiple-select"
		:options="options"
		:value="localSelectedItems"
		@input="handleInput($event)"
		:data-content="localSelectedItems.length > 0 ? '' : placeholder"
	>
		<template slot="menu" slot-scope="{ menuItem }">
			
			<div
				class="p-multiple-select--item"
				:class="{ 'p-multiple-select--item__selected': isSelected(menuItem) }"
			>
				{{ menuItem[prop] }}
			</div>
		</template>
	</multi-select>
</template>

<script>
	import MultiSelect from 'multiselect-dl';
	import { findIndex, propEq, reject } from 'ramda';

	export default {
		name: 'PMultipleSelect',
		data() {
			return {
				localSelectedItems: [],
			};
		},
		components: { MultiSelect },
		props: {
			options: {
				default: [],
				required: true,
			},
			prop: {
				required: true,
			},
			placeholder: {
				default: '',
			},
			selectedOptions: {
				default: [],
			},
		},
		methods: {
			handleInput([selectedItem]) {
				if (this.isSelected(selectedItem)) {
					this.localSelectedItems = reject(
						propEq(this.prop, selectedItem[this.prop]),
						this.localSelectedItems,
					);
				} else {
					this.localSelectedItems = [...this.localSelectedItems, selectedItem];
				}
				this.$emit('onChange', this.localSelectedItems);
			},
			isSelected(item) {
				const foundIndex = findIndex(
					propEq(this.prop, item[this.prop]),
					this.localSelectedItems,
				);
				return foundIndex > -1;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.p-multiple-select {
		border: 1px solid var(--app-color-info);
		border-radius: 5px;
		padding: 10px;
		user-select: none;

		&:before {
			content: attr(data-content);
			color: var(--app-color-primary);
			position: absolute;
			top: 4px;
		}

		& > * > .flex-display {
			gap: 5px;
		}

		&--item {
			cursor: pointer;
			text-align: left;
			padding: 8px 16px;
			color: var(--app-color-font-gray);
			border-bottom: 1px solid var(--app-color-gray);

			&__selected {
				background-color: var(--app-color-primary);
				color: white !important;
			}
		}

		.multi-select-menu {
			width: 100% !important;
		}

		.menu-list:last-child .p-multiple-select--item {
			border-bottom: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-multiple-select.vue